<ng-template #content>
    <ng-container *ngIf="!loading">
        <span class="h__pre-content" *ngIf="preContent">{{preContent}}</span>

        <span class="h__counter" *ngIf="counter !== null">{{counter}}</span>

        <span class="h__label" [ngClass]="{'-ellipsis': ellipsis}">
            <ng-content></ng-content>
        </span>

        <span class="h__post-content" *ngIf="postContent">{{postContent}}</span>
    </ng-container>

    <shared-loader-for-placeholder class="h__loader" [ngClass]="{'-center': center}" *ngIf="loading">
    </shared-loader-for-placeholder>
</ng-template>

<ng-container *ngIf="type; else emptyBlock">
    <h1 class="h {{headerSizeClass}}{{marginTop ? ' -margin-top-'+marginTop : ''}}{{marginBottom ? ' -margin-bottom-'+marginBottom : ''}}{{paddingTop ? ' -padding-top-'+paddingTop : ''}}{{paddingBottom ? ' -padding-bottom-'+paddingBottom : ''}}"
        [ngClass]="{'-inverted': inverted, '-brand-accent': brandAccent, '-center': center}">
        <ng-container *ngTemplateOutlet="content"></ng-container>
    </h1>
</ng-container>

<ng-template #emptyBlock></ng-template>
